export const environment = {
  production: true,
  pouchDbUrl: 'https://db.mc.zduniak.net/',
  GOOGLE_API_KEY: 'AIzaSyBqDOLRero8bDzj1VMOzkLqiY4-laS9Kbg',
  isAdmin: window.location.host.indexOf('tr-webapp') === 0 || window.location.host.indexOf('mc-webapp') === 0
};
